import { useQuery } from "react-query";
import { getNewHireConfieEmployeeCount } from "../../../../../actions/Employees";

const useGetNewHireConfieEmployeeCount = () => {
  return useQuery(
    "GetNewHireConfieEmployeeCount",
    getNewHireConfieEmployeeCount,
    {
      refetchOnWindowFocus: false,
    }
  );
};

export default useGetNewHireConfieEmployeeCount;
